module.exports = __webpack_public_path__ + "img/img9676blue.35dc70a0.jpg";